import Debug from 'debug'
import { useMutation } from '@connectrpc/connect-query'

import { delete$ } from '@jotta/grpc-connect-openapi/deviceQuery'
import {
  addBackgroundJob,
  type BackgroundJobStatus,
} from '@jotta/hooks/useBackgroundJobStore'

import { authTransport } from '../transport'

type ToastStatus = Extract<
  BackgroundJobStatus,
  'IN_PROGRESS' | 'SUCCESS' | 'FAILED'
>

const debug = Debug('jotta:files:emptyTrash')

export const useDeleteDeviceMutation = <
  T extends string | number | undefined,
>(options?: {
  onMutate?: () => T
  onSettled?: (
    status: ToastStatus,
    toastId: string | number | undefined,
  ) => void
}) =>
  useMutation(delete$, {
    transport: authTransport,
    onMutate: options?.onMutate,
    onSettled: (data, error, variables, toastId) => {
      const backgroundJobId = data?.backgroundJob?.id
      let status: ToastStatus
      if (backgroundJobId) {
        addBackgroundJob('DELETE_DEVICE', backgroundJobId, toastId)
        status = 'IN_PROGRESS'
      } else if (!error) {
        status = 'SUCCESS'
      } else {
        status = 'FAILED'
      }

      options?.onSettled?.(status, toastId)
    },
  })
